import React from "react";
import PropTypes from "prop-types";

import ShareLink from "cards/components/ShareLink";
import CopyLinkButton from "cards/components/CopyLinkButton";
import createShareLinks from "utils/createShareLinks";

import styles from "./ShareLinks.css";

function openInNewWindow(url) {
  return (e) => {
    e.preventDefault();
    const strParam = "width=500,height=400,resizable=yes";
    window.open(url, "Share story", strParam).focus();
  };
}

export default function ShareLinks({ permalink, headline }) {
  const shareLinks = createShareLinks(permalink, headline);
  return (
    <div className={styles.root}>
      {shareLinks.map((shareLink) => {
        return (
          <ShareLink key={shareLink.name}
            shareLinkConfig={shareLink}
            onClick={openInNewWindow(shareLink.url)}
            className={`gtm-${shareLink.name}`}/>
        );
      })}
      <CopyLinkButton permalink={permalink} />
    </div>
  );
}

ShareLinks.propTypes = {
  headline: PropTypes.string.isRequired,
  permalink:  PropTypes.string.isRequired,
};
